import { STREAMABLE_REGEX } from '../../../../../consts'

export const getStreamableVideoId = (link: string) => {
  if (!link.match(STREAMABLE_REGEX)) {
    return null
  }

  return link.match(STREAMABLE_REGEX)?.groups?.id
}
